// Module
var code = "<with-unison> <div class=\"new-toast cu-justify-content-between cu-align-items-center\" data-testid=\"toast-plain\"> <div>{{ title }}</div> <cu-icon name=\"close\" ng-click=\"close()\" class=\"close-icon\" data-testid=\"toast-close-button\"></cu-icon> </div> </with-unison> ";
// Exports
module.exports = code;